import { HttpClient } from '@angular/common/http';
import { AccountService } from '../../../services/account.service';
import { SCAMP_API } from 'src/environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../../services/account.service";
export class FuncionarioService {
    constructor(http, account) {
        this.http = http;
        this.account = account;
    }
    getEncarregados() {
        return this.http.get(`${SCAMP_API.accountApiV1}/encarregados`, { headers: this.account.composeHeaders() });
    }
    getEncarregadosPorEmpreiteira(empreiteiraId) {
        return this.http.get(`${SCAMP_API.accountApiV1}/encarregados-por-empreiteira/${empreiteiraId}`, { headers: this.account.composeHeaders() });
    }
    getFuncionarios() {
        return this.http.get(`${SCAMP_API.accountApiV1}/funcionarios`, { headers: this.account.composeHeaders() });
    }
    getEngenheiros() {
        return this.http.get(`${SCAMP_API.accountApiV1}/engenheiros`, { headers: this.account.composeHeaders() });
    }
    getEngenheirosPorEmpreiteira(empreiteiraId) {
        return this.http.get(`${SCAMP_API.accountApiV1}/engenheiros-por-empreiteira/${empreiteiraId}`, { headers: this.account.composeHeaders() });
    }
    getListaFuncionarios() {
        return this.http.get(`${SCAMP_API.accountApiV1}/lista-funcionarios`, { headers: this.account.composeHeaders() });
    }
    getListaFuncionariosPorEmpreteira(id) {
        return this.http.get(`${SCAMP_API.accountApiV1}/funcionarios-por-empreiteira/${id}`, { headers: this.account.composeHeaders() });
    }
    create(data) {
        return this.http.post(`${SCAMP_API.accountApiV1}/funcionario`, data, { headers: this.account.composeHeaders() });
    }
    read(id) {
        return this.http.get(`${SCAMP_API.accountApiV1}/funcionario/${id}`, { headers: this.account.composeHeaders() });
    }
    update(id, data) {
        return this.http.put(`${SCAMP_API.accountApiV1}/funcionario/${id}`, data, { headers: this.account.composeHeaders() });
    }
    delete(id) {
        return this.http.delete(`${SCAMP_API.accountApiV1}/funcionario/${id}`, { headers: this.account.composeHeaders() });
    }
    getAll() {
        return this.http.get(`${SCAMP_API.accountApiV1}/lista-funcionarios`, { headers: this.account.composeHeaders() });
    }
    isUniqueMatriculaFuncionario(matricula) {
        return this.http.post(`${SCAMP_API.accountApiV1}/matricula-funcionario-is-unique`, { matricula }, { headers: this.account.composeHeaders() });
    }
    search(parametro) {
        return this.http.get(`${SCAMP_API.accountApiV1}/funcionarios-search/${parametro}`, { headers: this.account.composeHeaders() });
    }
}
FuncionarioService.ngInjectableDef = i0.defineInjectable({ factory: function FuncionarioService_Factory() { return new FuncionarioService(i0.inject(i1.HttpClient), i0.inject(i2.AccountService)); }, token: FuncionarioService, providedIn: "root" });
